import styles from './Badge.module.scss';
import { EWithdrawStatus } from '../../../types/EWithdrawStatus';

interface IBadgeProps {
    status: EWithdrawStatus;
}

export const Badge = ({ status }: IBadgeProps) => {
    let badgeStyle = '';
    let text = '';

    switch (status) {
        case EWithdrawStatus.SUCCESS:
            badgeStyle = styles.success;
            text = 'Success';
            break;

        case EWithdrawStatus.IN_PROGRESS:
            badgeStyle = styles.inProgress;
            text = 'In Progress';
            break;

        case EWithdrawStatus.ERROR:
            badgeStyle = styles.error;
            text = status;
            break;

        case EWithdrawStatus.APPROVED:
            badgeStyle = styles.inProgress;
            text = 'Approved';
            break;

        case EWithdrawStatus.PROCESSING:
            badgeStyle = styles.inProgress;
            text = 'Processing';
            break;
    }

    return (
        <div className={styles.container}>
            <div className={[styles.badge, badgeStyle].join(' ')}>{text}</div>
        </div>
    );
};
